<template>
  <div>
    <v-alert v-if="protocol.related_protocol" :value="true" color="success" type="success">
      Skjemaet er ferdig utfylt med inventar fra innflyttingsprotokoll
    </v-alert>
    <v-flex xs12>
      <h2 class="text-center mb-3">Møblering og inventar</h2>
    </v-flex>
    <v-flex xs12 class="mb-2">
      <BooleanInput v-model="stepValues.bool" @update-fields="updateFields"></BooleanInput>
    </v-flex>
    <v-flex xs12 class="mb-3" v-if="stepValues.bool.isFurnished.value">
      <v-flex v-if="stepValues.relatedComment" xs12 class="m-4" style="border: 1px dashed orange">
        <span><strong>Kommentar fra innflytting:</strong> {{stepValues.relatedComment}}</span>
      </v-flex>
      <v-textarea
        box
        v-model="stepValues.comment"
        @input="updateFields"
        label="Kommentar"
        hint="Vennligst kommenter hva som medfølger boligen"
      ></v-textarea>
    </v-flex>
    <ImageUploadBox v-if="stepValues.bool.isFurnished.value" :images="stepValues.images" :relatedImages="stepValues.relatedImages"></ImageUploadBox>
    <StepButtons @next-page="next" @previous-page="previous" :step="this" />
  </div>
</template>

<script>
import step from "../../mixins/step";
export default {
  mixins: [step],
  mounted: function() {
    if(this.protocol.related_protocol) {
      if(this.protocol.related_protocol.steps.furnishing.saved_values.bool && !this.protocol.related_protocol.steps.furnishing.saved_values.loadedFromRelated) {
        this.protocol.related_protocol.steps.furnishing.saved_values.loadedFromRelated = true
        let values = JSON.parse( JSON.stringify(this.protocol.related_protocol.steps.furnishing.saved_values))
        this.stepValues.bool = values.bool
        this.stepValues.relatedImages = values.images
        this.stepValues.relatedComment = values.comment
      }
    }
  }
}
</script>
